var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.576904C11.1747 0.576904 7.50618 2.09647 4.80133 4.80133C2.09647 7.50618 0.576904 11.1747 0.576904 15C0.576904 18.8252 2.09647 22.4938 4.80133 25.1986C7.50618 27.9035 11.1747 29.4231 15 29.4231C18.8252 29.4231 22.4938 27.9035 25.1986 25.1986C27.9035 22.4938 29.4231 18.8252 29.4231 15C29.4231 11.1747 27.9035 7.50618 25.1986 4.80133C22.4938 2.09647 18.8252 0.576904 15 0.576904Z",
    fill: "url(#paint0_linear_627_2709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1755 8.50973L19.4741 22.3025C19.4741 22.3025 19.358 22.9328 18.5762 22.9328C18.1608 22.9328 17.9467 22.7352 17.9467 22.7352L12.0952 17.8797L9.23224 16.4367L5.55796 15.4595C5.55796 15.4595 4.90387 15.2705 4.90387 14.7297C4.90387 14.279 5.57671 14.0641 5.57671 14.0641L20.9488 7.95733C20.9481 7.95661 21.4183 7.78786 21.7608 7.78858C21.9714 7.78858 22.2116 7.87872 22.2116 8.14915C22.2116 8.32944 22.1755 8.50973 22.1755 8.50973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2789 19.6912L11.8082 22.1243C11.8082 22.1243 11.7007 22.2073 11.5572 22.2109C11.5075 22.2123 11.4541 22.2044 11.3993 22.1799L12.0945 17.8782L14.2789 19.6912Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2526 10.8144C19.1308 10.6557 18.9058 10.6269 18.7471 10.7473L9.23077 16.4422C9.23077 16.4422 10.7495 20.6913 10.981 21.4269C11.2132 22.1632 11.3993 22.1805 11.3993 22.1805L12.0945 17.8788L19.1849 11.3192C19.3435 11.1987 19.3731 10.973 19.2526 10.8144Z",
    fill: "#E0E7EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_2709",
    x1: 15,
    y1: 0.576904,
    x2: 15,
    y2: 29.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#156FBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.91655290e4cc7c46e9596aa250435f61.svg";
export { ForwardRef as ReactComponent };